<ng-container *ngrxLet="viewModel$; let model;">
  @if (model.cellValue) {
    <div class="flex items-start">
      <img [src]="model.cellValue | typeCellIcon"
           [alt]="model.cellValue"
           class="h-9 mr-4"/>
      <span>{{ ('COORDINATES.' + model.cellValue) | translate }}</span>
    </div>
  }
</ng-container>
